import React from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

const FamilyMemberRow = ({
    member,
    index,
    handleChange,
    handleRemove,
    fileUpload,
    nextLoader,
    DOBPickerComponent,
}) => {
    return (
        <div
            className={`grid gap-2 mb-4 w-full print:overflow-visible ${fileUpload ? "grid-cols-4" : "grid-cols-1 sm:grid-cols-2 md:grid-cols-4"
                }`}
        >
            {/* Name */}
            <div className={`px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md text-black text-sm`}>
                {fileUpload ? member.name : (
                    <>
                        <label className="w-24 sm:mr-2 md:mb-1 md:w-full text-sm font-medium text-black">Name*</label>
                        <input
                            type="text"
                            value={member.name}
                            onChange={(e) => handleChange(index, "name", e.target.value)}
                            placeholder="Name"
                            className="flex-1 w-full px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        />
                    </>
                )}
            </div>

            {/* Relationship */}
            <div className={`px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md text-black text-sm`}>
                {fileUpload ? member.relationship : (
                    <>
                        <label className="w-24 sm:mr-2 md:mb-1 md:w-full text-sm font-medium text-black">Relationship*</label>
                        <input
                            type="text"
                            value={member.relationship}
                            onChange={(e) => handleChange(index, "relationship", e.target.value)}
                            placeholder="Relationship"
                            className="flex-1 w-full px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        />
                    </>
                )}
            </div>

            {/* DOB */}
            <div className={`px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md text-black text-sm`}>
                {fileUpload ? member.dob : (
                    <>
                        <label className="w-24 sm:mr-2 md:mb-1 md:w-full text-sm font-medium text-black">DOB*</label>
                        {DOBPickerComponent ? (
                            <DOBPickerComponent
                                id="dob"
                                value={member.dob}
                                onChange={(date) => {
                                    const formattedDate = date
                                        ? `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
                                            .getDate()
                                            .toString()
                                            .padStart(2, "0")}/${date.getFullYear()}`
                                        : "";
                                    handleChange(index, "dob", formattedDate);
                                }}
                                disabled={nextLoader}
                                className="flex-1 w-full"
                            />
                        ) : (
                            <input
                                type="text"
                                value={member.dob}
                                onChange={(e) => handleChange(index, "dob", e.target.value)}
                                placeholder="mm/dd/yyyy"
                                className="flex-1 w-full px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                            />
                        )}
                    </>
                )}
            </div>

            {/* Phone */}
            <div className={`px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md text-black text-sm`}>
                {fileUpload ? member.mobile_number : (
                    <>
                        <label className="w-24 sm:mr-2 md:mb-1 md:w-full text-sm font-medium text-black">Phone*</label>
                        <input
                            type="text"
                            value={member.mobile_number}
                            onChange={(e) => handleChange(index, "mobile_number", e.target.value)}
                            placeholder="Phone"
                            className="flex-1 w-full px-2 py-2 bg-slate-50 border-b-2 border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        />
                    </>
                )}
            </div>
        </div>

    );
};


const FamilyMemberConsent = ({
    familyMembers,
    handleFamilyChange,
    handleRemoveFamilyMember,
    handleAddMember,
    fileUpload = false,
    nextLoader = false,
    DOBPickerComponent,
    title,
}) => {
    return (
        <div className="px-1 py-2 bg-white">
            <p className="border-t-4 border-b-4 border-gray-300 p-4 mt-4 text-lg font-semibold text-center text-black">
                Family Member Consent
            </p>

            <div className="text-black mt-2 text-sm md:text-base">
                <p>
                    With your permission, {title} may release your protected health information to a family member, or another person involved in your care or payment for your care.
                </p>
                <p>
                    Please identify the person or persons who are involved in your care or the payment of your care that you can authorize to receive your protected health information. This may include your spouse, parent, siblings, children, close friend, or guardian. Please list below:
                </p>
            </div>

            {/* Table Header */}
            <div
                className={`grid gap-2 mt-4 mb-2 font-medium text-sm text-black ${fileUpload ? "grid-cols-4" : "grid-cols-1 sm:grid-cols-2 md:grid-cols-4"
                    }`}
            >
                <div className={`${!fileUpload ? "hidden sm:block" : "block"}`}>
                    Name <span className="text-red-500">*</span>
                </div>

                <div className={`${!fileUpload ? "hidden sm:block" : "block"}`}>
                    Relationship <span className="text-red-500">*</span>
                </div>

                <div className={`${!fileUpload ? "hidden sm:block" : "block"}`}>
                    DOB <span className="text-red-500">*</span>
                </div>

                <div className={`${!fileUpload ? "hidden sm:block" : "block"}`}>
                    Phone <span className="text-red-500">*</span>
                </div>
                {!fileUpload && <div className="block"></div>}
            </div>



            {/* Family Rows */}
            {familyMembers.map((member, index) => (
                <FamilyMemberRow
                    key={index}
                    member={member}
                    index={index}
                    handleChange={handleFamilyChange}
                    handleRemove={handleRemoveFamilyMember}
                    fileUpload={fileUpload}
                    nextLoader={nextLoader}
                    DOBPickerComponent={DOBPickerComponent}
                />
            ))}

            {/* Add Member Button */}
            {!fileUpload && (
                <div className="flex justify-start mt-4">
                    <button
                        type="button"
                        onClick={handleAddMember}
                        className="flex items-center text-blue-500 hover:text-blue-700"
                    >
                        <FaPlus className="mr-2" /> Add Family Member
                    </button>
                </div>
            )}
        </div>
    );
};

export default FamilyMemberConsent;
